import React from 'react'
import { FeaturedLayout } from '../../layouts'
import EstadoCuentaTab from './EstadoCuentaTab'
import { useTemporadaActiva } from './useTemporadaActiva'
import TemporadaSelector from './TemporadaSelector'

const PagosEstadoCuenta = () => {
  const { temporadaId, temporadas, setTemporadaId } = useTemporadaActiva()

  return (
    <FeaturedLayout
      title="Estado de cuenta"
      subtitle="Consulta saldos por cuenta y comparte el acceso a los tutores"
    >
      <EstadoCuentaTab
        temporadaId={temporadaId}
        temporadaSelector={<TemporadaSelector temporadas={temporadas} value={temporadaId} onChange={setTemporadaId} className="w-full sm:w-auto" />}
      />
    </FeaturedLayout>
  )
}

export default PagosEstadoCuenta
